import { AXIS_GREY, HORIZONTAL_OFFSET, LABEL_GREY, VERTICAL_OFFSET } from './chart-constants'

interface VerticalAxisProps {
    height: number
    scalingFactor: number
    type: 'number' | 'price'
    values: number[]
    width: number
}

function formatAxisValue(value: number, type: 'number' | 'price'): string {
    if (type === 'price') {
        return `$${value}`
    }
    return String(value)
}

export function VerticalAxis({ height, scalingFactor, type, values, width }: VerticalAxisProps) {
    return (
        <svg>
            {values.map((value, index) => {
                const scaledValue = value * scalingFactor
                const lineYPosition = height - scaledValue + VERTICAL_OFFSET
                const textYPosition = height - scaledValue + VERTICAL_OFFSET * 1.5
                const isLast = index === values.length - 1

                return (
                    <g key={value}>
                        {!!value && (
                            <text x={0} y={textYPosition} fill={LABEL_GREY} fontSize={12}>
                                {formatAxisValue(value, type)}
                            </text>
                        )}
                        <line
                            x1={HORIZONTAL_OFFSET}
                            x2={width}
                            y1={lineYPosition}
                            y2={lineYPosition}
                            stroke={AXIS_GREY}
                            strokeDasharray={isLast ? 'none' : '3,3'}
                            strokeWidth={1}
                        />
                    </g>
                )
            })}
        </svg>
    )
}
